import "./Bonus.scss";
import {MAX_LEVEL} from "../LevelBlock/LevelBlock";

const RADIUS = 62;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

// Кільцевий індикатор: скільки з максимальних +5% бонусу вже відкрито
const Bonus = ({user}) => {
    const bonus = user.personalBonus || 0;
    const share = Math.min(bonus / MAX_LEVEL, 1);

    return (
        <div className="pb-gauge">
            <div className="pb-gauge-ring">
                <svg viewBox="0 0 150 150" width="150" height="150" aria-hidden="true">
                    <defs>
                        <linearGradient id="pb-gauge-grad" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0" stopColor="#4046eb" />
                            <stop offset="1" stopColor="#1a8bff" />
                        </linearGradient>
                    </defs>
                    <circle cx="75" cy="75" r={RADIUS} className="pb-gauge-track" />
                    <circle
                        cx="75"
                        cy="75"
                        r={RADIUS}
                        className="pb-gauge-arc"
                        stroke="url(#pb-gauge-grad)"
                        strokeDasharray={`${CIRCUMFERENCE * share} ${CIRCUMFERENCE}`}
                        transform="rotate(-90 75 75)"
                    />
                </svg>
                <div className="pb-gauge-value">+{bonus}%</div>
            </div>
            <div className="pb-gauge-caption">особистий бонус</div>
            <div className="pb-gauge-max">максимум +{MAX_LEVEL}%</div>
        </div>
    );
};

export default Bonus;
